<template>
  <div class="refund">
    <CustomHeader
      ref="header"
      title="申请退款"
    />
    <div class="refund-content">
      <div class="title">
        退款订单
      </div>
      <div class="cell">
        <span>订单号</span>
        <span>{{ item.orderNo }}</span>
      </div>
      <div class="title between">
        退款项
        <div
          v-if="false"
          class="align-center"
          @click="open = true"
        >
          <img
            src="https://m.hellobike.com/resource/helloyun/15697/k1HnNgvRJx.png"
            class="warn"
          >规则说明
        </div>
      </div>
      <div class="cell">
        <span>退款金额</span>
        <span>￥{{ item.payAmount }}</span>
      </div>
    </div>
    <div class="refund-bottom">
      <quark-button
        class="btn"
        @click="orderRefund"
      >
        提交申请
      </quark-button>
    </div>
    <quark-dialog
      type="confirm"
      title="规则说明"
      :open="open"
      @confirm="open = false"
      @close="open = false"
    >
      <div class="content">
        使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知 使用须知
      </div>
    </quark-dialog>
  </div>
</template>

<script>
import 'quarkd/lib/button';
import 'quarkd/lib/dialog';
import Toast from 'quarkd/lib/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Native } from '@hb/mbridge';
import logger from '~mall/common/utils/logger';
import Header from '~mall/components/Header.vue';
import { refundOrder } from '~mall/model/apis/orderApis';
import { isHelloFamilyApp } from '~mall/common/env/env';

export default {
  name: 'RefundOrder',
  components: {
    CustomHeader: Header,
  },
  data() {
    return {
      item: this.$route.query || {},
      open: false,
    };
  },
  mounted() {
    if (isHelloFamilyApp) {
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBar',
        params: { isShowStatusBar: true },
      });
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
      });
    }
  },
  methods: {
    close() {
      this.open = false;
    },

    async orderRefund() {
      const loading = Toast.loading('正在退款中', {
        duration: 0,
      });
      try {
        const res = await refundOrder({
          categoryId: this.item.categoryId,
          orderNo: this.item.orderNo,
          sourceType: '1',
        });
        loading.hide();
        if (res.code === 0) {
          Toast.text('退款申请成功，退款金额将原路返回', {
            duration: 3000,
          });
          window.history.go(-1);
        } else {
          Toast.text(res.msg || res.errMsg, {
            duration: 3000,
          });
        }
        logger(res, 'res');
      } catch (error) {
        logger(error, 'error');
      }
      UBT.clickButton({
        pageId: 'couponmall_orderlistdetail',
        buttonName: 'couponmall_orderlistdetail_refund',
        categoryId: 'hellomall',
        businessInfo: {
          businessId: this.item.categoryId,
          itemID: this.item.spuId,
          goodsprice: this.item.payAmount,
          orderId: this.item.orderNo,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.refund {
  height: 100vh;
  background: #F0F3F5;
  display: flex;
  flex-direction: column;

  &-content {
    flex: 1;

    .title {
      padding: 16px 16px 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, "PingFang SC";
      font-weight: 400;
      line-height: 20px;
      color: #879099;
    }

    .cell {
      padding: 15px 16px;
      background: #fff;
      display: flex;
      align-items: center;
      line-height: 22px;

      span:first-of-type {
        flex-shrink: 0;
        margin-right: 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, "PingFang SC";
        font-weight: 400;
        color: #5A6066;
      }

      span:last-of-type {
        flex: 1;
        font-size: 16px;
        font-family: PingFangSC-Regular, "PingFang SC";
        font-weight: 400;
        color: #879099;
        display: flex;
        flex-wrap: wrap;
        overflow-wrap: break-word;
        word-break: break-all
      }
    }

    .warn {
      width: 16px;
      height: 16px;
      margin-right: 7px;
    }
  }

  &-bottom {
    height: 72px;
    background: #FFF;
    box-shadow: 0 -4px 8px 0 rgba(0,0,0,6%);
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      flex: 1;
      height: 48px;
      background: #FA4614;
      border-radius: 8px;
      border: none;
      margin: 0 16px;
      font-size: 18px;
      font-family: PingFangSC-Medium, "PingFang SC";
      font-weight: 500;
      color: #FFF;
    }
  }

  .between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .align-center {
    display: flex;
    align-items: center;
  }

  .popover-content {
    position: relative;
    width: 300px;
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 20%);
    padding: 10px;
    border-radius: 8px;
  }

  .content {
    text-align: left;
    margin-bottom: 16px;
  }
}

</style>
<style>
:root {
  --quark-theme-color: linear-gradient(270deg, #FC6F4E 0%, #F72626 100%)
}
</style>
